import React from 'react';
import { clsx } from 'clsx';
import { dashboardPanel, dashboardPanelHover } from './dashboardStyles';

type Props = {
    children: React.ReactNode;
    className?: string;
    hover?: boolean;
    as?: 'div' | 'section' | 'article';
    id?: string;
    onClick?: () => void;
    'data-testid'?: string;
};

/** Elevated Railway-style panel for dashboard widgets. */
export const DashboardSurface: React.FC<Props> = ({
    children,
    className,
    hover = false,
    as: Tag = 'div',
    id,
    onClick,
    'data-testid': testId,
}) => (
    <Tag
        id={id}
        data-testid={testId}
        onClick={onClick}
        className={clsx(dashboardPanel, hover && dashboardPanelHover, className)}
    >
        {children}
    </Tag>
);
